const EmptyMenu = () => <div />;

export default EmptyMenu;
